module.exports = __webpack_public_path__ + "img/pic_2_tc.53f9f742.png";